import { render, staticRenderFns } from "./DashboardReferralCard.html?vue&type=template&id=20036127&scoped=true&"
import script from "./DashboardReferralCard.js?vue&type=script&lang=js&"
export * from "./DashboardReferralCard.js?vue&type=script&lang=js&"
import style0 from "./DashboardReferralCard.scss?vue&type=style&index=0&id=20036127&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20036127",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSkeletonLoader})
